/**
 * Created by StoneWang on 2020/11/27.
 */
import React from 'react';

class Notice extends React.Component {
  render() {
    return <div>
      {this.props.children}
    </div>
  }
};
export default Notice;



// WEBPACK FOOTER //
// ./src/routes/carousel/index.js